import React, { useEffect, useMemo, useState } from 'react';
import AladdinHint from '../../../../../components/AladdinHint/AladdinHint';
import AppContentContainer from '../../../../../components/AppContentContainer/AppContentContainer';
import { tracking } from '../../../../../utils/tracking';
import { trackDirect } from '../../../../../store/analytics/api';
import HotTopicContentSlides from '../../hotTopic/HotTopicContentSlidesNew';
import { getStudioPackEntries } from '../utils/studioPacks';

interface TemplatePickerProps {
  intl: any;
  history: any;
  hotTopic: any;
  renderHeaderButton: (show: boolean) => void;
  [key: string]: any;
}

const TemplatePicker: React.FC<TemplatePickerProps> = props => {
  const { intl, history, hotTopic, renderHeaderButton } = props;
  const [contents, setContents] = useState<any>({});

  const studioHotTopic = useMemo(() => {
    if (!hotTopic || !Array.isArray(hotTopic.data)) {
      return hotTopic;
    }

    return {
      ...hotTopic,
      data: hotTopic.data.reduce(
        (packs: any[], item: any) => packs.concat(getStudioPackEntries(item)),
        []
      )
    };
  }, [hotTopic]);

  useEffect(() => {
    setContents(studioHotTopic || {});
  }, [studioHotTopic]);

  useEffect(() => {
    renderHeaderButton(false);
  }, [renderHeaderButton]);

  useEffect(() => {
    tracking('Hot Topic Studio Accessed');
    trackDirect('useHotTopicStudio');
  }, []);

  const handleModeChange = (mode: string) => {
    if (mode === 'existing') {
      tracking('Click on Hot Topic Studio - Back to Existing');
      // Replace (not push) so the back button returns to the real previous page
      // instead of stepping back through the existing/studio mode toggle.
      history.replace('/hot_topic');
    }
  };

  const handleItemClick = (item: any) => {
    const templateId = String((item && item.id) || '').replace(/^featured-/, '');
    if (!templateId) {
      return;
    }
    tracking('Click on Hot Topic Studio Template', { id: templateId });
    history.push(`/hot_topic_studio/${encodeURIComponent(templateId)}`);
  };

  return (
    <AppContentContainer>
      <div>
        <div style={{ padding: '8px 0' }}>
          <AladdinHint
            containerProps={{ justify: 'center' }}
            title={intl.formatMessage({ id: 'aladdin-hot-topic-title' })}
            helpCenter="c92"
          />
          <HotTopicContentSlides
            {...({
              ...props,
              hotTopic: contents,
              eventType: 'hot topic',
              // Studio picker: no view/like counts (existing /hot_topic keeps them).
              statistics: undefined,
              categoryViewPath: '/hot_topic_studio_category',
              tagViewPath: '/hot_topic_studio_tag',
              enableLanguages: true,
              mode: 'studio',
              onModeChange: handleModeChange,
              HotTopicItemProps: {
                enableLanguages: true,
                onItemClick: handleItemClick,
                showStudioCover: true,
                shouldShowStatistic: false
              }
            } as any)}
          />
        </div>
      </div>
    </AppContentContainer>
  );
};

export default TemplatePicker;
